import React from "react";
import "./tageComponents.scss";
import {Tag, Badge,} from "antd";

const TageComponents = (props) => {
  
  const itemArray = [];
  if (props?.tagArray?.length !== 0){
    if (props?.tagKey){
      props?.tagArray && props?.tagArray.map((item)=>{
        itemArray.push(<Tag color="#FFF4C9" style={{color:"#282828"}}>{ item[props?.tagKey] ? `${item[props?.tagKey]}` : ""}</Tag>)
      })
    } else {
      props?.tagArray && props?.tagArray.map((item)=>{
        itemArray.push(<Tag color="#FFF4C9" style={{color:"#282828"}}>{typeof item === 'object' && item !== null ? "" : `${item}`}</Tag>)
      })
    }
  }

  return (itemArray.length === 0 ? "-" :
    <Badge 
      className="page-list ffc aifs mb-0 notificationBadge"
      count={props?.tagArray?.length}
      // overflowCount={1}
      style={{
        backgroundColor: '#FACC06',
        color:"#282828",
        fontSize: "11px",
        fontWeight: "500",
      }}
    >
      {itemArray}
    </Badge>
  )
};

export default TageComponents;